/**
 * Human-readable module type names. Auto-prettifying the raw slug
 * (video_meeting_link → "Video Meeting Link") produced wrong product names —
 * overrides win, the slug fallback covers new types.
 */
const TYPE_DISPLAY_NAMES: Record<string, string> = {
  video_meeting_link: 'Embedded link',
  video_url_embed: 'Video',
  rich_text: 'Text',
  image_embed: 'Image',
  pdf_file: 'PDF',
  source_code_file: 'Code file',
  scorm_zip: 'SCORM package',
  evaluation: 'Quiz',
  feedback: 'Survey',
};

export function moduleTypeLabel(type: string): string {
  return (
    TYPE_DISPLAY_NAMES[type] ??
    type.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase())
  );
}
